import { apiCall, createQueryString } from "../imports"

const PREFIX = "blog/posts/tags"

export default {

    findTags(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
}